import { createTRPCReact } from '@trpc/react-query';
import { httpBatchLink } from '@trpc/client';
import type { AppRouter } from '@shared/trpc/appRouter';

// Create the tRPC React hooks
export const trpc = createTRPCReact<AppRouter>();

// Create tRPC client with simple URL
export const trpcClient = trpc.createClient({
  links: [
    httpBatchLink({
      url: '/trpc',
    }),
  ],
});